import { doc, getDoc } from 'firebase/firestore';

/**
 * Load the latest line + order from Firestore for sticker printing.
 * Callers often hold list/page cache that can predate edits made after the page loaded.
 */
export async function fetchStickerPrintPayload(db, lineId, orderIdHint) {
  if (!lineId) {
    throw new Error('Missing line id for sticker print');
  }

  const lineSnap = await getDoc(doc(db, 'orderLines', lineId));
  if (!lineSnap.exists()) {
    throw new Error(`Line ${lineId} not found`);
  }

  const line = { id: lineSnap.id, ...lineSnap.data() };
  const orderId = orderIdHint || line.orderId;
  if (!orderId) {
    return { line, order: null };
  }

  const orderSnap = await getDoc(doc(db, 'orders', orderId));
  const order = orderSnap.exists() ? { id: orderSnap.id, ...orderSnap.data() } : null;
  return { line, order };
}
